require('./hireCardVirtualOnlyDebitSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { catalogue, analyticsId } = require('../analytics/hireCardVirtualOnlyDebitAnalytics');

class HireCardVirtualOnlyDebitSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
        } = this.props;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-virtual-only-debit-success__summary">
                <div className="col-xs-6">
                    <FormattedText
                        className="hire-card-virtual-only-debit-success__summary-title"
                        value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_summarySelectedName"
                    />
                    <div className="hire-card-virtual-only-debit-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="hire-card-virtual-only-debit-success__summary-title"
                        value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_summarySelectedAccount"
                    />
                    <div className="hire-card-virtual-only-debit-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                </div>
            </div>
        );
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const text = !!email ? 'hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_successWarningTextSentByEmail' : 'hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="hire-card-virtual-only-debit-success__message">
                <OKMessage type="informative">
                    <FormattedText value={text} injectedStrings={injectedString} />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immProfile,
            immHireCardImageSelector,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_successTitle')}
                    tealium={catalogue[analyticsId.VIRTUAL_ONLY_DEBIT_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-virtual-only-debit-success">
                        <div className="row">
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-card-virtual-only-debit-success__card-image"
                                immImageData={immImageData}
                            />
                            <div className="col-xs-8">
                                <div className="hire-card-virtual-only-debit-success__text">
                                    <FormattedText value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_successMessageText" />
                                </div>
                            </div>
                        </div>
                        {summarySection}
                        {messageSection}
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardVirtualOnlyDebitSuccess.propTypes = {
    immAccount: PropTypes.object,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardVirtualOnlyDebitSuccess;
